import { themeStyle } from '@src/theming';

import { ModalTheme } from './types';

export const defaultTheme: ModalTheme = {
  padding: '55px 10px',
  // We need to add 1 because legacy popover is opened in root div while layers from ui-kit are opened via portal
  // Hence, they are located lower in the DOM tree and if this modal is opened from the Drawer, it will be under it
  zIndex: themeStyle.zIndexL1 + 1,
};
